var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h2',[_vm._v(" "+_vm._s(_vm.readOnlyErrorMessage)+" ")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._v(" For additional help, contact us at "),_c('a',{staticClass:"text-underline",attrs:{"href":"mailto:support@axure.com"}},[_vm._v("support@axure.com")]),_vm._v(". ")])
}]

export { render, staticRenderFns }